import React from 'react';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

class MoreInfoPage extends React.Component {

    state = {
    };

    componentDidMount() {
    }

   
    render() {

        return (
            <Grid container spacing={24}>
                <Grid item xs={12}>
                    <Typography>More Info</Typography>
                    <Button
                        variant="contained"
                        color="primary"
                        classes={{

                        }}
                        onClick={this.props.onBack}
                    > BACK
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        classes={{

                        }}
                        onClick={this.props.onNext}
                    > NEXT
                    </Button>
                </Grid>
                </Grid>
        );
    }
}

MoreInfoPage.propTypes = {
    onNext: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired
};

export default MoreInfoPage;